'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'chalkboard';
var width = 576;
var height = 512;
var aliases = ["blackboard"];
var unicode = 'f51b';
var svgPathData = 'M552 432H416V384c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v48H24C10.75 432 0 442.7 0 456C0 469.3 10.75 480 24 480h528c13.25 0 24-10.75 24-24C576 442.7 565.3 432 552 432zM368 432h-96v-32h96V432zM80 88c0-4.406 3.594-8 8-8h400c4.406 0 8 3.594 8 8v312H544V88C544 57.13 518.9 32 488 32H88C57.13 32 32 57.13 32 88v312h48V88z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChalkboard = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;